<template>
  <div class="wise-public-footer">
    <!-- <div v-if="isShow" class="wise-public-footer"> -->
    <div class="content">
      <div class="inner">
        <div :gutter="20" class="flex">
          <div class="span-3">
            <div class="grid-content">
              <img v-if="!agent" class="project-logo" src="https://uifox-public.oss-cn-hangzhou.aliyuncs.com/common/official/freesailing_logo.png" alt="logo" />
              <img v-else-if="agent && companyLogo" class="project-logo" :src="companyLogo" alt="logo" />
              <img v-else class="project-logo" src="https://uifox-public.oss-cn-hangzhou.aliyuncs.com/common/market_v2/home/default_icon.png" alt="logo" style="width: 40px" />
            </div>
          </div>
          <div class="span-10">
            <div class="grid-content">
              <div class="grid-title" v-if="!agent">杭州未斯科技有限公司</div>
              <div class="grid-title" v-else>
                {{ infoMsg && infoMsg.companyName ? infoMsg.companyName : '' }}
              </div>
              <template v-if="!agent">
                <div>地址：杭州市余杭区菜鸟智谷产业园一期A2-1002室</div>
                <div>咨询热线：0571-86395960</div>
                <div>邮箱：cd@uifox.com.cn</div>
              </template>
            </div>
          </div>
          <div :class="!agent ? 'span-5' : 'span-3'">
            <div class="grid-content">
              <div class="grid-title">产品</div>
              <div style="display: flex">
                <div style="width: 100px">
                  <div class="grid-content-item"><el-link :underline="false" @click="toUrl('/cps', 'shcps')">预配舱单-上海</el-link></div>
                  <div class="grid-content-item"><el-link :underline="false" @click="toUrl('/cpsqd', 'qdcps')">预配舱单-青岛</el-link></div>
                  <div class="grid-content-item" v-if="!agent"><el-link :underline="false" @click="toUrl('/freight', '')">运价查询</el-link></div>
                  <div class="grid-content-item" v-if="!agent"><el-link :underline="false" @click="toUrl('/track-sh', 'shTrack')">货物跟踪</el-link></div>
                  <div class="grid-content-item"><el-link :underline="false" @click="toUrl('/vgm', 'vgm')">VGM发送</el-link></div>
                </div>
                <div v-if="!agent" style="margin-left: 20px">
                  <div class="grid-content-item" v-if="!agent"><el-link :underline="false" @click="toUrl('/fullLink', 'shTrack')">全链路跟踪</el-link></div>
                  <div class="grid-content-item" v-if="!agent"><el-link :underline="false" @click="toUrl('/ams', 'ams')">AMS发送</el-link></div>
                  <div class="grid-content-item" v-if="!agent"><el-link :underline="false" @click="toUrl('/afr', 'afr')">AFR发送</el-link></div>
                  <div v-if="!agent"><el-link :underline="false" @click="toUrl('/em', 'em')">EM&ACI发送</el-link></div>
                  <div v-if="!agent"><el-link :underline="false" @click="toUrl('/ics', 'ics')">ICS2发送</el-link></div>
                </div>
              </div>

              <!-- <div class="pointer" @click="toUrl('/cps')">
                上海-预配舱单
              </div> -->
              <!-- <div class="pointer" @click="toUrl('/cpsqd')">
                青岛-预配舱单
              </div> -->
              <!-- <div class="pointer" @click="toUrl('/vgm')">VGM发送</div> -->
              <!-- <template v-if="!agent">
                <div class="pointer" @click="toUrl('/accurate')">
                  船期查询
                </div>
                <div class="pointer" @click="toUrl('/track-sh')">
                  货物跟踪
                </div>
                <div class="pointer" @click="toUrl('/ams')">AMS 发送</div>
                <div class="pointer" @click="toUrl('/em')">
                  EM & ACI 发送
                </div>
                <div class="pointer" @click="toUrl('/afr')">AFR 发送</div>
                <div class="pointer" @click="toUrl('/freight')">运价查询</div>
                <div class="pointer" @click="toUrl('/fullLink')">全链路跟踪</div>
              </template> -->
            </div>
          </div>
          <template v-if="!agent">
            <div class="span-3">
              <div class="grid-content">
                <div class="grid-title">关于我们</div>
                <div><el-link :underline="false" @click="toUrl('/about')">公司介绍</el-link></div>

                <!-- <div class="pointer" @click="toUrl('/aboutUs')">
                  公司介绍
                </div> -->
              </div>
            </div>
            <div class="span-5">
              <div class="grid-code">
                <img class="qr-code" src="https://uifox-public.oss-cn-hangzhou.aliyuncs.com/common/official/qr_code.png" alt="" />
                <div>扫码关注公众号</div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
    <div class="copy">
      <span>
        浙ICP备20009552号 © 2019 - {{ new Date().getFullYear() }}杭州未斯科技有限公司
        <a href="https://beian.miit.gov.cn/" target="_blank" class="text-col-3 mx-2 blue"> 浙ICP备20009552号-7 </a>
      </span>
    </div>
  </div>
</template>

<script>
// import { state } from '@/store/index'
import { mapMutations } from 'vuex'
import { go2Page, getRouterName } from '@/utils/functions'
import { fetchProductList } from '@/api/user'

let timer

/**
 * 全局页脚
 */
export default {
  name: 'AppFooter',
  data() {
    return {
      agent: false,
      loginSuccessUrl: '',
      companyLogo: '',
      infoMsg: '',
      isShow: true
    }
  },
  computed: {},
  mounted() {
    // 区分是不是代理人
    this.agent = localStorage.getItem('isAgentSystem') ? true : false
    setTimeout(() => {
      this.isShow = true
    })

    let infoMsg = localStorage.getItem('infoMsg') && JSON.parse(localStorage.getItem('infoMsg'))
    this.infoMsg = infoMsg

    if (infoMsg && infoMsg.companyLogo && infoMsg.companyLogo.indexOf('http') > -1) {
      this.companyLogo = infoMsg.companyLogo
    } else if (infoMsg && infoMsg.companyLogo && infoMsg.companyLogo.indexOf('http') < 0) {
      this.companyLogo = 'https://' + infoMsg.companyLogo
    }
  },
  methods: {
    ...mapMutations('user', ['setCurrentTab', 'setCurrentHref']),

    async toUrl(href, code) {
      if (href === location.pathname) return

      let { isLogin, hasCompany, userInfo, openedProducts, openedStatus } = this.$store.getters

      let productEnable = openedStatus
      let productStatus = openedProducts

      const isBool = await go2Page({ href, code, isLogin, hasCompany, userInfo, productEnable, productStatus })

      if (isBool) {
        timer = setTimeout(() => {
          let path = location.pathname
          this.setCurrentTab(getRouterName(path))
          this.setCurrentHref(href)
          window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
          clearTimeout(timer)
        }, 20)
      }
    }
  }
}
</script>

<style scoped lang="less">
.wise-public-footer {
  position: relative;
  z-index: 99;

  .content {
    padding: 48px 0;
    background-color: white;

    .inner {
      width: 1200px;
      margin: 0 auto;

      .grid-content {
        line-height: 24px;
        font-size: 14px;
        color: #666666;
        font-weight: 400;

        .grid-title {
          font-size: 16px;
          color: #333333;
          font-weight: 600;
          padding-bottom: 12px;
        }

        .grid-content-item {
          margin-bottom: 5px;
        }

        .project-logo {
          width: 108px;

          ::v-deep .el-image__inner {
            width: 100%;
          }
        }

        ::v-deep .el-link {
          font-weight: 400;
        }
      }

      .grid-code {
        font-size: 14px;
        text-align: center;
        width: fit-content;

        .qr-code {
          width: 120px;
          height: 120px;
          margin-bottom: 2px;
        }

        & > div {
          color: #333333;
          font-weight: 400;
        }
      }
    }
  }

  .copy {
    width: 100%;
    height: 40px;
    line-height: 40px;
    font-weight: 400;
    text-align: center;
    font-size: 12px;
    color: #666666;
    background-color: #f0f3fb;
  }

  .flex {
    display: flex;

    .span-3 {
      min-width: 12.5%;
      width: 12.5%;
    }

    .span-5 {
      min-width: 20.83333%;
      width: 20.83333%;
    }

    .span-10 {
      min-width: 41.66667%;
      width: 41.66667%;
    }
  }
}

.pointer {
  cursor: pointer;
}

.blue {
  color: #2d8cf0;
}
</style>
